import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LINK_PATH } from '../../../../constant';
import { useDropdownKeyboardNavigation } from '../../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import NavigationList from '../../../../components/NavigationList/NavigationList';
import useKeyboardNavigation from '../../../../components/Custom_Hooks/useKeyboardNavigation';

const AccountBook = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { userData = null } = useSelector((state) => state.auth);

    const hasPermission = React.useCallback((reportName) => {
        if (userData?.login_type === 'user' && Array.isArray(userData?.permissions)) {
            const pagePermissions = userData.permissions.find(p => p.name?.toLowerCase() === reportName?.toLowerCase() && p.category?.toLowerCase() === 'reports');
            return pagePermissions ? (pagePermissions.view || pagePermissions.create) : false;
        }
        return true;
    }, [userData]);

    const keyMap = {
        'c': '',
        'l': hasPermission('Ledger') ? (nav) => nav('/ledgerbook', { state: { resetId: Date.now() } }) : '',
        'g': '',
        'v': '',
        't': '',
        'y': '',
        'r': '',
        's': '',
        'p': '',
        'j': '',
        'd': '',
        'e': '',
        'u': '',
    };

    useKeyboardNavigation(keyMap);

    const data = [
        { to: '/createmasters', text: 'Cash/Bank Book(s)' },
        ...(hasPermission('Ledger') ? [{ to: '/ledgerbook', text: 'Ledger', state: { resetId: Date.now() } }] : []),
        { to: '/chartofaccountmasters', text: 'Group Summary' },
        { to: '/chartofaccountmasters', text: 'Group Vouchers' },
        { to: '/voucherstransaction', text: 'Contra Register' },
        { to: '/daybooktransaction', text: 'Payment Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Receipt Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Sales Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Purchase Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Journal Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Debit Note Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Credit Note Register', state: { resetId: Date.now() } },
        { to: '/daybooktransaction', text: 'Voucher Clarification', state: { resetId: Date.now() } }
    ];
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: data,
        state: true,
        onItemSelect: (item) => {
            if (['/ledgerbook', '/current_date', '/period'].includes(location.pathname)) {
                return;
            }
            if (item.state) {
                navigate(item.to, { state: item.state })
            } else {
                navigate(item.to)
            }
        },

    });
    return (
        <NavigationList
            data={data}
            selectedItemIndex={selectedItemIndex}
            setSelectedItemIndex={setSelectedItemIndex}
            title='Account Books'
            first_heading='SUMMARY'
            secound_heading='REGISTERS'
        />
    )
}

export default React.memo(AccountBook);
